import { useSelector } from 'react-redux';
import { QueryClientProvider } from 'react-query';
import { modalSelect } from 'app/store/modalSlice';
import ModalComponent from './ModalComponent';

const GlobalModal = ({ queryClient }) => {
  const modalPack = useSelector(modalSelect);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        {modalPack.map(({ key, ...props }, index) => (
          <ModalComponent key={key} {...props} index={index} />
        ))}
      </QueryClientProvider>
    </>
  );
};

export default GlobalModal;
